<template>
  <div class="st- -sub">
    <div id="sidebar-overlay"></div>
    <div class="inner- -layer-4 -sub">
      <div class="_nav">
        <div class="_list">
          <ul>
            <!--
            <li><a href="">お知らせ</a></li>
            <li><a>プロフィール編集</a>
              <ul>
                <li><a href="http://localhost:8888/mypage/user/">ユーザー情報・内容更新</a></li>
                <li><a href="http://localhost:8888/mypage/sitter/">サポーター情報・内容更新</a></li>
              </ul>
            </li>
            -->
            <li><a>プロフィール編集</a>
              <ul>
                <li><router-link :to="{name: 'MypageSittersProfile'}">ユーザー情報・内容更新</router-link></li>
                <li><router-link :to="{name: 'MypageSittersQualifications'}">資格・内容更新</router-link></li>
                <li><router-link :to="{name: 'MypageSittersPublicRelations'}">PR・内容更新</router-link></li>
                <li><router-link :to="{name: 'MypageSittersSupportSettings'}">サポート設定・内容更新</router-link></li>
                <li><router-link :to="{name: 'MypageSittersRehabilitationPlaces'}">療育場所・内容更新</router-link></li>
              </ul>
            </li>
            <li><a>スケジュール編集</a>
              <ul>
                <li><router-link :to="{name: 'MypageSittersSchedules'}">スケジュール入力・内容更新</router-link></li>
                <li><router-link :to="{name: 'MypageSittersMonthlySchedules'}">月別スケジュール入力</router-link></li>
              </ul>
            </li>
            <li><a>リクエスト</a>
              <ul>
                <li><router-link :to="{name: 'MypageSittersRequests'}">予約一覧</router-link></li>
              </ul>
            </li>
            <li><a>保護者さん</a>
              <ul>
                <li><router-link :to="{name: 'MypageSittersMessagesThreads'}">メッセージ一覧</router-link></li>
              </ul>
            </li>
  <!-- 
            <li><a>入金</a>
              <ul>
                <li><a href="">入金一覧</a></li>
              </ul>
            </li>
  -->
            <li><a href="/static/page/logout.html">ログアウト</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      member: null
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "../../../assets/mypage/css/style_struct.css";

// 以下で無理やり上書き
.st-.-sub {
  min-width: 300px !important;
  width: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mypage/sitters/MypageSittersAside.vue